import i18next from 'script-loader!i18next/i18next.min';
import 'script-loader!i18next-browser-languagedetector/i18nextBrowserLanguageDetector.min';


